import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { UpdateOrganizationStatus } from '../models/UpdateOrganizationStatus';

@Injectable()
export class OrganizationService {
  constructor(private http: Http) {}

  get(orgId): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.get.replace('{orgId}', orgId);
    return this.http.get(url).map(res => {
      return res.json();
    });
  }

  filter(filter, skip, take): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.filter
        .replace('{skip}', skip)
        .replace('{take}', take);
    return this.http.post(url, filter).map(res => {
      return res.json();
    });
  }

  delete(orgId: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.delete.replace('{orgId}', orgId.toString());
    return this.http.delete(url).map(res => {
      return res;
    });
  }

  save(org: any): Observable<any> {
    const url = environment.api.baseUrl + environment.api.organizations.save;
    return this.http.post(url, org).map(res => {
      return res.json();
    });
  }

  updateStatus(
    orgId: number,
    status: UpdateOrganizationStatus[]
  ): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.updateStatus.replace(
        '{orgId}',
        orgId.toString()
      );
    return this.http.post(url, status).map(res => {
      return res;
    });
  }

  getStatus(orgId: number): Observable<UpdateOrganizationStatus[]> {
    const url =
      environment.api.baseUrl +
      environment.api.organizations.getStatus.replace(
        '{orgId}',
        orgId.toString()
      );
    return this.http.get(url).map(res => {
      return res.json().map(item => new UpdateOrganizationStatus(item));
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/organization.service.ts